import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Recycling_2: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 800,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path // all
					d="M200.1 80.63l-21.63 34.16-30.57 48.29a3.78 3.78 0 01-6.54-.26l-7.58-14.47-3.54-6.76A99.74 99.74 0 00112.91 259l-36.55 21.1a143.81 143.81 0 0131.36-181.46l-4-7.73-7.66-14.53a3.77 3.77 0 013.5-5.52L151.44 73l45.62 1.86a3.77 3.77 0 013.04 5.77zM383.74 190.48l-28.13 43.64-24.74 38.37a3.77 3.77 0 01-6.53-.31l-18.48-36-26.12-50.83a3.78 3.78 0 013.54-5.51l16.32.81 7.62.37a99.72 99.72 0 00-92.36-74.44l.34-42.2a143.81 143.81 0 01140.46 119l8.72.43 16.38.81a3.77 3.77 0 012.98 5.86zM331.11 289a143.82 143.82 0 01-172.71 63.76l-4.66 7.38L145 374a3.77 3.77 0 01-6.53-.26l-24.16-46L93 287.36a3.78 3.78 0 013.49-5.53l40.4 1.61L194 285.7a3.78 3.78 0 013.05 5.79l-8.73 13.81-4.07 6.45A99.76 99.76 0 00294.54 268z"
				/>
			</svg>
		</animated.span>
	)
}

export { Recycling_2 }
